import { Col, Row } from "react-bootstrap";
import ShowImagePanel from "./ShowImagePanels";
import { Link } from "react-router";
import { useAppSelector } from "../../../../services/hooks";
import { formatPrice } from "../../../../helpers/formatPrice";

export default function CategoryPanel50({ content, path }: any) {
    const currency = useAppSelector((state) => state.user.currency)
    return (
        <Col xs={12} md={6}>
            <Row className="rounded-4 m-1 my-2 p-3 shadow border-2 border border-warning warrningGradientYellowToWhiteBottom ">
                <Col xs={12}>
                    <h2 className="fs-3 fw-bolder text-dark">{content.categoryName}</h2>
                    <div className="text-black-50 small pb-2 d-none d-xl-block">
                        Mamy w tej kategorii
                        <span className="fw-bolder"> {content.productsQuantity} </span>
                        produktów
                    </div>
                </Col>
                <Col xs={6} md={12} className="row align-items-center mx-auto text-center d-none d-xl-flex">
                    <ShowImagePanel content={content} maxImages={2} />
                </Col>
                <Col xs={6} md={12} className="row align-items-center mx-auto text-center d-xl-none">
                    <h2 className="fs-6 fw-bolder text-dark">{content.products[0].name}</h2>
                    <h2 className="fs-6 text-dark">{formatPrice(content.products[0].price, currency)}</h2>
                </Col>
                <Col xs={6} md={12} className="text-center py-2">
                    {/* TODO Linki Polecamy */}
                    <Link to={path} className="btn btn-danger fw-bold mb-2 mb-xxl-0 me-1 d-none d-xl-inline">
                        Polecamy <span className="bi bi-caret-up-fill"></span>
                    </Link>
                    <Link to={path} className="btn btn-success mb-2 mb-xxl-0 fw-bold">
                        Zobacz więcej w kategorii <span className="bi bi-caret-right-fill"></span>
                    </Link>
                </Col>
            </Row >
        </Col >
    )
}